import { createSlice } from "@reduxjs/toolkit";
import { GetInvoices, GetSaleDetail } from "services/saleDetails/saleDetails.service";
import { toast } from 'react-toastify';

export const invoiceListSlice = createSlice({
  name: "invoiceList",
  initialState: {
    invoiceList: [],
    invoiceListLoading: false,
    invoiceListError: null,
  },
  reducers: {},
  extraReducers: 
  (builder) => {
    builder.addCase(GetInvoices.pending, (state) => {
      state.invoiceListLoading = true
    });

    builder.addCase(GetInvoices.fulfilled, (state, action) => {
      toast.dismiss();
      // toast.success('Promise resolved 👌');

      state.invoiceList = action.payload
      state.invoiceListLoading = false
      state.invoiceListError = null
    });

    builder.addCase(GetInvoices.rejected, (state, action) => {
      toast.dismiss();
      toast.error('Promise rejected 🤯 😣')

      state.invoiceListLoading = false
      state.invoiceListError = action.error?.message
    });
  },
});

export const saleDetailSlice = createSlice({
  name: "saleDetail",
  initialState: {
    saleDetail: [],
    saleDetailLoading: false,
    saleDetailError: null,
  },
  reducers: {},
  extraReducers: 
  (builder) => {
    builder.addCase(GetSaleDetail.pending, (state) => {
      state.saleDetailLoading = true
    });

    builder.addCase(GetSaleDetail.fulfilled, (state, action) => {
      toast.dismiss();
      // toast.success('Promise resolved for sale detail👌');

      state.saleDetail = action.payload
      state.saleDetailLoading = false
      state.saleDetailError = null
    });

    builder.addCase(GetSaleDetail.rejected, (state, action) => {
      toast.dismiss();
      toast.error('Promise rejected for sale detail 🤯 😣')

      state.saleDetailLoading = false
      state.saleDetailError = action.error?.message
    });
  },
});